import type { CampaignFormState } from "./campaign-form-fields";

export function formatInputDate(value: unknown): string {
  if (!value) return "";
  const s = String(value).trim();
  if (!s) return "";

  // If already in YYYY-MM-DD format:
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return s;
  }

  // If ISO string like 2026-09-22T... or 2026-09-22 ...:
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    return s.slice(0, 10);
  }

  // If in DD-MM-YYYY or DD/MM/YYYY:
  const dmyMatch = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
  if (dmyMatch) {
    const [, d, m, y] = dmyMatch;
    return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
  }

  // Try parsing Date:
  const d = new Date(s);
  if (!isNaN(d.getTime())) {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return "";
}

export function campaignFormToRecord(
  record: Record<string, unknown>
): CampaignFormState {
  const amountType = String(record.amount_type ?? "variable");
  const fixedAmount =
    record.fixed_amount ??
    (amountType === "fixed" &&
    record.min_contribution !== null &&
    record.min_contribution !== undefined &&
    record.max_contribution !== null &&
    record.max_contribution !== undefined &&
    String(record.min_contribution) === String(record.max_contribution)
      ? record.min_contribution
      : "");

  const rawStartDate =
    record.start_date ??
    record.startDate ??
    record.from_date ??
    record.start_date_time;
  const rawEndDate =
    record.end_date ??
    record.endDate ??
    record.to_date ??
    record.end_date_time;

  return {
    ...record,
    donation_type: record.type_of_donation ?? record.donation_type ?? "",
    donation_type_name:
      record.type_of_donation_name ?? record.donation_type_name ?? "",
    main_category: record.category ?? record.main_category ?? "",
    main_category_name: record.category_name ?? record.main_category_name ?? "",
    sub_category: record.sub_category ?? "",
    sub_category_name:
      record.sub_category_title ?? record.sub_category_name ?? "",
    start_date: formatInputDate(rawStartDate),
    end_date: formatInputDate(rawEndDate),
    amount_type: amountType,
    fixed_amount: fixedAmount,
    min_contribution: record.min_contribution ?? "",
    max_contribution: record.max_contribution ?? "",
    is_active: record.is_active !== false,
    allow_donation_after_target: record.allow_donation_after_target === true,
  };
}
